import React from 'react';
import { useSpeechInput } from '../../api/useSpeechInput';
import '../../styles/mic-button.css';

interface MicButtonProps {
    onResult: (text: string) => void;
    className?: string;
    disabled?: boolean;
}

const MicButton: React.FC<MicButtonProps> = ({ onResult, className = '', disabled = false }) => {
    const { listen, stopListening, isListening, isSupported } = useSpeechInput({ onResult });

    if (!isSupported) return null;

    const handleClick = () => {
        if (isListening) {
            stopListening();
        } else {
            listen();
        }
    };

    return (
        <button
            type="button"
            className={`mic-btn ${isListening ? 'mic-btn--listening' : ''} ${className}`}
            onClick={handleClick}
            disabled={disabled}
            title={isListening ? 'Stop recording' : 'Voice input'}
            aria-label={isListening ? 'Stop recording' : 'Voice input'}
        >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="9" y="2" width="6" height="12" rx="3"/>
                <path d="M5 10a7 7 0 0 0 14 0"/>
                <line x1="12" y1="19" x2="12" y2="22"/>
                <line x1="8" y1="22" x2="16" y2="22"/>
            </svg>
        </button>
    );
};

export default MicButton;
